import { CloseRounded } from '@mui/icons-material';
import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';

import {
  ContentContainer,
  DialogActionsButtonsWrapper,
  DialogActionsWrapper,
  DialogContentWrapper,
  DialogHeader,
  DialogHeaderCloseButton,
  DialogWrapper,
  Separator,
} from './Dialog.style';
import { DialogProps } from './Dialog.type';

export function Dialog({
  title,
  content,
  primaryButton,
  cancelButton,
  isOpen,
  stepper,
  footer,
  handleCloseModal,
  hideCloseButton,
  fitsContent,
  maxWidth,
  isPadding = true,
}: DialogProps): JSX.Element {
  const theme = useTheme();
  const isFullScreen = useMediaQuery(theme.breakpoints.down('xs'));

  return (
    <DialogWrapper
      $fitsContent={fitsContent}
      fullScreen={isFullScreen}
      open={isOpen}
      disableEnforceFocus
      maxWidth={maxWidth}
      onClose={handleCloseModal}
    >
      <ContentContainer>
        <Box
          sx={{
            padding: (theme) => `${theme.spacing(4)} ${theme.spacing(6)}`,
            backgroundColor: (theme) => theme.palette.background.default,
          }}
        >
          {stepper && <DialogHeader>{stepper}</DialogHeader>}
          {title && (
            <Typography fontSize="28px" lineHeight="36px" component="span">
              {title}
            </Typography>
          )}

          {!hideCloseButton && (
            <DialogHeaderCloseButton type="button" onClick={handleCloseModal}>
              <CloseRounded />
            </DialogHeaderCloseButton>
          )}
        </Box>
        <Box
          sx={{
            overflowY: 'auto',
            padding: (theme) =>
              isPadding ? `${theme.spacing(4)} ${theme.spacing(6)}` : undefined,
          }}
        >
          <DialogContentWrapper>{content}</DialogContentWrapper>
        </Box>
      </ContentContainer>
      {cancelButton && primaryButton && (
        <>
          <Separator />
          <DialogActionsWrapper>
            <DialogActionsButtonsWrapper>
              {cancelButton} {primaryButton}
            </DialogActionsButtonsWrapper>
          </DialogActionsWrapper>
        </>
      )}
      {footer}
    </DialogWrapper>
  );
}
